import { createUseStyles } from 'react-jss';

const styles = {
  pageHeader: { overflow: 'visible !important' },
  wrapper: {
    paddingLeft: '2rem',
    paddingRight: '2rem'
  },
  wrapperSpacer: {
    marginTop: '5px'
  }
};

export const useStyles = createUseStyles(styles, {
  name: 'CreateQueryHeaderContent'
});
